import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import MobileEpisodeReview from "../components/MobileComponents/MobileEpisodeReview";
import StatusDropdown from "../components/SeriesComponents/StatusDropdown";
import AdSection from "../components/SeriesComponents/AdSection";
import EpisodeList from "../components/SeriesComponents/EpisodeList";
import FullEpisode from "../components/SeriesComponents/FullEpisode.js";
import episodeStore from "../stores/episodeStore.js";
import SeasonBar from "../components/SeriesComponents/SeasonBar.js";


export default function SeriesPage() {
    const location = useLocation();
    
    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);
    const [selectedEpisode, setSelectedEpisode] = useState(null);

    const [expandedOverview, setExpandedOverview] = useState(false);


    const [navOpen, setNavOpen] = useState(null);

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
    }, []);

    useEffect(() => {
        if (!selectedShow?._id) return;
    }, [selectedShow?._id, staStore.status]);

    useEffect(() => {
        if (location.state?.selectedShow) {
            setSelectedShow(location.state.selectedShow);
            console.log("selected show = " + selectedShow?.title);
        }
    }, [location.state]);

    const currentStatus =
    selectedShow?._id
        ? staStore.status?.find(
            (s) =>
            s.targetType === "series" &&
            String(s.seriesId) === String(selectedShow._id)
        )?.userStatus ?? ""
        : "";

    const [selectedSeason, setSelectedSeason] = useState(1);
        
    useEffect(() => {
        staStore.fetchStatus();
        setSelectedSeason(1);
    }, [selectedShow]);
    
    const [statusDDOpen, setStatusDDOpen] = useState(false); // for the status dropdown
    const [seasonDDOpen, setSeasonDDOpen] = useState(false); // for the season dropdown

    const statusRef = useRef(null);

     // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusRef.current && !statusRef.current.contains(event.target)) {
                setStatusDDOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

     // Scroll past the header on mobile
    useEffect(() => {
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 90, behavior: 'auto' });
        }
    }, []);

    // episode stuff
    const epStore = episodeStore();
    const [episodeStatuses, setEpisodeStatuses] = useState([]);

    useEffect(() => {
        if (!selectedShow?._id) return;
        epStore.fetchEpisodesBySeries(selectedShow._id);
    }, [selectedShow?._id]);

    // refetches when you back out of an episode, see the note below
    useEffect(() => {
        if (!selectedShow?._id || selectedEpisode) return;

        const loadStatuses = async () => {
            const statuses = await staStore.fetchEpisodeStatuses(selectedShow._id);
            setEpisodeStatuses(statuses);
        };
        loadStatuses();
    }, [selectedShow?._id, selectedEpisode]);

    const episodes =
        epStore.episode?.filter((ep) => ep.seriesId === selectedShow?._id) || [];

    const seasonStatuses =
        staStore.status?.filter(
            (s) =>
                s.seriesId === selectedShow?._id &&
                s.targetType === "episode" &&
                Number(s.season) === Number(selectedSeason)
    ) ?? [];

    return (
        <div className="app-wrapper tv-static">
            <header class="header">
                <Header 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                />
            </header>
            <content className="content">
                <nav className="nav">
                    <NavigationBar 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                    />
                </nav>
                <main className="main">
                  
                    {/* {selectedEpisode ? (
                        <div className="midSectionHeader">
                            <FullEpisode
                                selectedEpisode={selectedEpisode}
                                setSelectedEpisode={setSelectedEpisode}
                                seasonStatuses={seasonStatuses}
                            />
                        </div>
                    ) : */}
                    {selectedShow ? ( 
                         <div className="midSection">
                            <div className="coverImageFade">
                                <div className="coverImage" 
                                style={{
                                    backgroundImage: `url('${selectedShow?.fanart}')`,
                                }}>
                                </div>
                            </div>
                            <div className="midSectionHeader" >  
                                <h2 className="showTitle">{selectedShow.title}</h2>
                                <div className="seriesInfoDetailsRow">
                                    <p className="seriesInfoYear">{selectedShow.year}</p>
                                    <p className="seriesInfoDetails">{selectedShow.numberOfSeasons} season{selectedShow.numberOfSeasons != 1 && <span>s</span>}</p>
                                    <p className="seriesInfoGenres">{selectedShow.genres?.join(", ")}</p>
                                </div>
                                <div className="seriesInfoDetailsRow">
                                    <p
                                        className={`seriesInfoOverview ${
                                            expandedOverview ? "" : "seriesInfoOverviewClamped"
                                        }`}
                                        onClick={() => setExpandedOverview(!expandedOverview)}
                                        >
                                        {selectedShow.overview}
                                    </p>
                                </div>
                                <div className="seriesInfoStatusDropdown" ref={statusRef}>
                                    <StatusDropdown
                                        selectedShow={selectedShow}
                                        currentStatus={currentStatus}
                                        statusDDOpen={statusDDOpen}
                                        setStatusDDOpen={setStatusDDOpen}/>
                                </div>
                                <hr></hr>
                                <div className="seriesInfoRow2"><img
                                        src={`/assets/companyLogos/${selectedShow.network}.png`}
                                        alt={selectedShow.network + " logo"}
                                        className="logoImg"
                                        onError={(e) => {
                                            const span = document.createElement("span");
                                            span.textContent = selectedShow.network;
                                            span.className = "seriesInfoDetails";
                                            e.currentTarget.replaceWith(span);
                                        }}
                                    />
                                    <p className="seriesInfoDetails">{selectedShow.originalCountry}, {selectedShow.originalLanguage}</p>
                                    <p className="seriesInfoDetails">{selectedShow.airingStatus}</p>
                                </div>
                                <hr></hr>
                            </div>
                            <div className="adSection">
                                <AdSection></AdSection>
                            </div>
                            <div className="midAlignmentDiv">
                                <div>
                                    <SeasonBar 
                                        selectedShow={selectedShow}
                                        selectedSeason={selectedSeason}
                                        setSelectedSeason={setSelectedSeason}
                                        seasonDDOpen={seasonDDOpen}
                                        setSeasonDDOpen={setSeasonDDOpen}
                                        episodes={episodes}
                                        seasonStatuses={seasonStatuses}
                                    />
                                    <EpisodeList
                                        selectedEpisode={selectedEpisode}
                                        setSelectedEpisode={setSelectedEpisode}
                                        selectedShow={selectedShow}
                                        selectedSeason={selectedSeason}
                                        episodes={episodes}
                                        seasonStatuses={seasonStatuses}
                                        episodeStatuses={episodeStatuses}
                                    />
                                </div>
                                <div className="clearStyleDiv"></div>
                            </div>
                        </div>
                    ) : null }

                </main>
                <aside className="right">
                    <div className="rightPanel">
                    </div>
                </aside>
            </content>
            <div class="footer"><Footer/></div>
        </div>
    )
}